
import { Vue, Component, Prop } from "vue-property-decorator";
import { User, StatusEnum } from "@/CodegenTypes";

import { sumBy, first } from "lodash";
import { formatDollar } from "@/helpers/formatDollar";
import { queries } from "@/apollo";
import * as legacyApollo from "@/apollo/legacySmartQuery";
import { useTranslation } from "@/store/translation";
import { customMoment } from "@/main";

type TtDownlineSummaryRow = {
  userId: User["userId"];
  username: User["username"];
  status: StatusEnum;
  amount: number;
};

@Component({
  mixins: [legacyApollo.legacySmartQueries({
    downlineSummaryRows: {
      query: queries.userAndDownlineTtBetSummary,
      skip() {
        return !this.userId;
      },
      variables() {
        return {
          releaseDate: customMoment(this.selectedStartReleaseDate)
            .startOf("day")
            .toDate(),
          behalfOf: this.userId,
        };
      },
      update(data) {
        return data.downlineTtBetSummary;
      },
    },
  })],
})
export default class TtDownlineSummary extends Vue {
  @Prop({ required: true }) userId!: User["userId"];
  formatDollar = formatDollar;

  t = (text: string) => useTranslation().$t(text);

  downlineSummaryRows = [] as TtDownlineSummaryRow[];

  get selectedStartReleaseDate() {
    const query = this.$route.query.startReleaseDate;
    return Array.isArray(query) ? first(query) : query;
  }

  get downlineSummaryTotal() {
    const data = this.downlineSummaryData;
    return {
      amount: formatDollar(sumBy(data, (d) => d.amount)),
    };
  }

  get downlineSummaryData() {
    return this.downlineSummaryRows || [];
  }
}
